<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('affiliateRelationManage.queryCondition') }}</span>
          </div>
          <el-form :inline="true" :model="affiliateRelationManageInfo.conditions" class="demo-form-inline">
            <el-form-item>
              <el-input
                v-model="affiliateRelationManageInfo.conditions.relationLevel"
                :placeholder="$t('affiliateRelationManage.selectRelationLevel')"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="_queryAffiliateRelationMethod">{{ $t('common.query') }}</el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('affiliateRelationManage.relationTableInfo') }}</span>
            <el-button
              type="primary"
              size="small"
              class="float-right"
              @click="_openAddAffiliateRelationModal"
            >
              <i class="el-icon-plus"></i>
              {{ $t('affiliateRelationManage.addRelation') }}
            </el-button>
          </div>
          <el-table
            :data="affiliateRelationManageInfo.affiliateRelations"
            border
            style="width: 100%"
          >
            <el-table-column
              prop="arId"
              :label="$t('affiliateRelationManage.relationId')"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="auId"
              :label="$t('affiliateRelationManage.affiliateId')"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="userId"
              :label="$t('affiliateRelationManage.recommendedUserId')"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="relationLevel"
              :label="$t('affiliateRelationManage.relationLevel')"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="expireTime"
              :label="$t('affiliateRelationManage.expireTime')"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="createTime"
              :label="$t('affiliateRelationManage.createTime')"
              align="center"
            ></el-table-column>
            <el-table-column
              :label="$t('common.operation')"
              align="center"
              width="200"
            >
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  @click="_openEditAffiliateRelationModel(scope.row)"
                >{{ $t('common.edit') }}</el-button>
                <el-button
                  size="mini"
                  type="danger"
                  @click="_openDeleteAffiliateRelationModel(scope.row)"
                >{{ $t('common.delete') }}</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="affiliateRelationManageInfo.conditions.page"
            :page-size="affiliateRelationManageInfo.conditions.row"
            layout="total, prev, pager, next"
            :total="affiliateRelationManageInfo.total"
            class="pagination"
          ></el-pagination>
        </el-card>
      </el-col>
    </el-row>

    <add-affiliate-relation ref="addAffiliateRelation"></add-affiliate-relation>
    <edit-affiliate-relation ref="editAffiliateRelation"></edit-affiliate-relation>
    <delete-affiliate-relation ref="deleteAffiliateRelation"></delete-affiliate-relation>
  </div>
</template>

<script>
import { listAffiliateRelation } from '@/api/affiliate/affiliateRelationApi'
import AddAffiliateRelation from '@/components/affiliate/addAffiliateRelation'
import EditAffiliateRelation from '@/components/affiliate/editAffiliateRelation'
import DeleteAffiliateRelation from '@/components/affiliate/deleteAffiliateRelation'

export default {
  name: 'AffiliateRelationManage',
  components: {
    AddAffiliateRelation,
    EditAffiliateRelation,
    DeleteAffiliateRelation
  },
  data() {
    return {
      affiliateRelationManageInfo: {
        affiliateRelations: [],
        total: 0,
        records: 1,
        moreCondition: false,
        conditions: {
          relationLevel: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this._listAffiliateRelations(1, 10)
  },
  methods: {
    handleCurrentChange(val) {
      this._listAffiliateRelations(val, this.affiliateRelationManageInfo.conditions.row)
    },
    _listAffiliateRelations(page, rows) {
      this.affiliateRelationManageInfo.conditions.page = page
      this.affiliateRelationManageInfo.conditions.row = rows
      listAffiliateRelation(this.affiliateRelationManageInfo.conditions).then(res => {
        this.affiliateRelationManageInfo.total = res.total
        this.affiliateRelationManageInfo.records = res.records
        this.affiliateRelationManageInfo.affiliateRelations = res.data
      }).catch(error => {
        console.log('请求失败处理', error)
      })
    },
    _openAddAffiliateRelationModal() {
      this.$refs.addAffiliateRelation.open()
    },
    _openEditAffiliateRelationModel(row) {
      this.$refs.editAffiliateRelation.open(row)
    },
    _openDeleteAffiliateRelationModel(row) {
      this.$refs.deleteAffiliateRelation.open(row)
    },
    _queryAffiliateRelationMethod() {
      this._listAffiliateRelations(1, 10)
    }
  }
}
</script>

<style scoped>
.pagination {
  margin-top: 20px;
  text-align: right;
}
.float-right {
  float: right;
}
</style>